import { isSameDay } from 'date-fns'

import { TimeRange } from 'types'
import { extendRangeToUtcDayLimits } from 'utils/time/extendRangeToUtcDayLimits'

export const getInitialRangeState = (range: TimeRange) => {
  if (isSameDay(range.from, range.to)) {
    const { from, to } = extendRangeToUtcDayLimits(range)

    return { from: new Date(from), to: new Date(to) }
  }

  return { from: new Date(range.from), to: new Date(range.to) }
}
